import type { FC } from "react";
import { Icon } from "@/ui/components/primitives";
import type { TFooterNavigationLink } from "./Footer.config";

type TFooterSocialNavigationProps = {
  links: TFooterNavigationLink[];
};

export const FooterSocialNavigation: FC<TFooterSocialNavigationProps> = ({
  links,
}) => (
  <nav
    aria-label="Social footer navigation"
    data-component="FooterSocialNavigation"
  >
    <ul className="flex items-center justify-center gap-4 md:gap-5 xl:gap-6">
      { links.map((link) => (
        <li key={link.id}>
          <a
            href={link.href}
            aria-label={link.ariaLabel ?? link.label}
            className="flex items-center justify-center text-sys-white"
          >
            { link.icon ? (
              <Icon icon={link.icon} className="w-10 xl:w-16" />
            ) : (
              <span className="sr-only">{ link.label }</span>
            ) }
          </a>
        </li>
      )) }
    </ul>
  </nav>
);

FooterSocialNavigation.displayName = "FooterSocialNavigation";
